import {
  groupItemListOptions,
  sortItemListOptionsByAvailability,
  useAdaptVariantPackToItemListOption,
} from '@/contexts/item-context-utils';
import { ItemListOption } from '@/contexts/item-context-types';
import { ItemsContext_VariantsPackFieldsFragment } from '@/types';
import { useAvailabilityStatusConfig } from './use-dynamic-config-value';
import { useCallback } from 'react';
import { useItemDisplayOptions } from '@/contexts/new-order-context';
import { VariantPackOrderCountsMap } from '@/screens/order-inbounds/types';

export type VariantPacksAdapter = (
  variantPacks: ItemsContext_VariantsPackFieldsFragment[],
  promotionOverrideUUID?: string,
  variantPackOrderCountsMap?: VariantPackOrderCountsMap,
) => ItemListOption[];

export const useAdaptAndGroupVariantPacks = (sortAvailability = true) => {
  const adaptVariantPackToItemListOption =
    useAdaptVariantPackToItemListOption();
  const itemDisplayOptions = useItemDisplayOptions();
  const availabilityStatusConfig = useAvailabilityStatusConfig();

  return useCallback<VariantPacksAdapter>(
    (
      variantsPacks: ItemsContext_VariantsPackFieldsFragment[],
      promotionOverrideUUID?: string,
      variantPackOrderCountsMap?: VariantPackOrderCountsMap,
    ) => {
      const itemListOptions = groupItemListOptions(
        variantsPacks.map((vp) =>
          adaptVariantPackToItemListOption(
            vp,
            promotionOverrideUUID,
            variantPackOrderCountsMap?.get(vp.uuid),
          ),
        ),
        itemDisplayOptions,
      );
      return sortAvailability
        ? sortItemListOptionsByAvailability(
            itemListOptions,
            availabilityStatusConfig,
          )
        : itemListOptions;
    },
    [
      adaptVariantPackToItemListOption,
      availabilityStatusConfig,
      itemDisplayOptions,
      sortAvailability,
    ],
  );
};
